module.exports = __webpack_public_path__ + "static/img/3aw.ab78396c.webp";